<style scoped>
iframe {
    border: none;
    width: 100%;
    vertical-align: bottom;
}
</style>

<template>
    <!-- <div ref="frameContainer" style="height: 100%;width: 100%;padding: 0px 20px 20px 20px;">
        <iframe style="width: 100%;height: 100%;" v-if="isShowIframe" ref="iframe" :src="url" @load="resize">
            <p>您的浏览器不支持 iframe 标签,请从列表中下载预览</p>
        </iframe>
    </div> -->
</template>

<script>

export default {
    name: 'web_common_biframe_index',
    data() {
        return {
            url: null,
            isShowIframe: false,

        }
    },
    async created() {

        let url = decodeURIComponent(this.$route.query.url)
        if (url.indexOf('?') == -1) {
            url += '?_='
        }
        this.url = url + '&ssoToken=' + localStorage.getItem('ssoToken');
        console.log(this.url)
        this.isShowIframe = true

    },
    mounted() {
        window.addEventListener('resize', this.resize);
    },
    methods: {
        //根据窗口尺寸设置组件大小
        resize() {
            return;
            this.$nextTick(() => {

                const height = this.$refs.iframe.frameContainer.offsetHeight;
                const iframe = this.$refs.iframe
                if (iframe) {
                    iframe.style.height = `${height}px`;
                }
            });
        },

    },
    activated() {
        this.resize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize);
    },
}
</script>